// extracted by mini-css-extract-plugin
module.exports = {"container":"Checkbox_container__RlSZT","label":"Checkbox_label__C7_92","error":"Checkbox_error__fFw0z"};